var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5957 20H5.40426L2 6L7 9L12 2L17 9L22 6L18.5957 20Z",
    fill: "url(#paint0_linear_6144_94)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6144_94",
    x1: 12,
    y1: 30.5,
    x2: 12,
    y2: -3.50274e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433988,
    stopColor: "#A46609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717581,
    stopColor: "#F2B820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "#977623"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.15b690659de76d0dd48f8343ec83d925.svg";
export { ForwardRef as ReactComponent };